// Packages:
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Position } from 'react-flow-renderer';
import hasNodeMoved from '../../../../lib/hasNodeMoved';

// Redux:
import { setSelectedNode } from '../../../../redux/actions/studioActions';

// Styles:
import {
  MessageNodeWrapper,
  MessageNodeLabel,
  Body,
  Description,
  Field,
  StyledHandle
} from './styles';

// Functions:
const MessageNode = ({ data }) => {
  // Constants:
  const dispatch = useDispatch();
  const { id, label, message } = data;

  // Ref:
  const wrapperRef = useRef(null);

  // State:
  const studio = useSelector((state) => state.studio);
  const [clickOrigin, setClickOrigin] = useState({ x: 0, y: 0 });

  // Functions:
  const handleMouseDown = useCallback(
    (e) => {
      if (e.button === 2) e.stopPropagation();
      if (e.button === 0) {
        setClickOrigin({ x: e.clientX, y: e.clientY });
        dispatch(setSelectedNode(data));
      }
    },
    [data, dispatch]
  );

  const handleMouseUp = useCallback(
    (e) => {
      if (e.button === 0) {
        if (hasNodeMoved(clickOrigin, e)) return;
      }
    },
    [clickOrigin]
  );

  // Effects:
  useEffect(() => {
    wrapperRef.current.addEventListener('mousedown', handleMouseDown);
    wrapperRef.current.addEventListener('mouseup', handleMouseUp);
  }, [handleMouseDown, handleMouseUp, clickOrigin, studio.selectedNode]);

  // Return:
  return (
    <MessageNodeWrapper
      ref={wrapperRef}
      style={{
        backgroundColor: studio.selectedNode?.id === id ? '#401FFF' : '#FFFFFF',
        borderColor: '#401FFF'
      }}
    >
      <StyledHandle
        type="target"
        position={Position.Top}
        style={{
          backgroundColor: 'blue',
          top: '-15px'
        }}
      />
      <StyledHandle
        type="source"
        position={Position.Bottom}
        style={{
          backgroundColor: 'green',
          bottom: '-15px'
        }}
      />
      <MessageNodeLabel
        htmlFor="text"
        style={{
          color: studio.selectedNode?.id === id ? '#FFFFFF' : '#333533'
        }}
      >
        {label}
      </MessageNodeLabel>
      <Body>
        <Description>
          <Field isActive={studio.selectedNode?.id === id}>
            {message.length === 0 ? (
              <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
                Write a message...
              </span>
            ) : message.length >= 30 ? (
              `${message.slice(0, 25).trim()}..`
            ) : (
              message
            )}
          </Field>
        </Description>
      </Body>
    </MessageNodeWrapper>
  );
};

// Exports:
export default MessageNode;
